import { Backdrop, CircularProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { AddFlex, CustomText } from "./reusableStyles";
import { primaryActionColor } from "../utils/constants";

const Image = styled.div`
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border-radius: 4px;
  object-fit: cover;
  background: ${(props) =>
    props.tempURL?.length > 0
      ? `url(${props.tempURL}) no-repeat center center / cover`
      : "grey"};
`;

const FileInput = styled.input`
  display: none;
`;

const LabelButton = styled.label`
  border: 1px solid ${primaryActionColor};
  padding: 6px 8px 6px 8px;
  border-radius: 8px;
`;

function ImageUploadComponent({ disabled, isLoading, tempURL, handleGetFile }) {
  const [openGallery, setOpenGallery] = useState(false);
  const inputRef = useRef();
  const _handleGetFile = (e) => {
    const url = URL.createObjectURL(e.target.files[0]);
    handleGetFile(e.target.files[0], url);
  };

  return (
    <>
      <AddFlex alignItems="center">
        <Image tempURL={tempURL}>
          {isLoading && (
            <CircularProgress
              size={"14px"}
              color="info"
              sx={{ color: "white" }}
            />
          )}
        </Image>
        {!disabled && (
          <AddFlex
            flexDirection="column"
            margin="0 0 0 20px"
            border={`1px solid ${primaryActionColor}`}
            padding={"6px 8px 6px 8px"}
            borderRadius="8px"
            onClick={() => inputRef.current.click()}
          >
            <CustomText color="#000000AF" fontSize="12px">
              Upload Image
            </CustomText>
            <FileInput
              ref={inputRef}
              id="fileInput"
              type="file"
              disabled={disabled}
              onChange={_handleGetFile}
              accept="image/*"
            />
          </AddFlex>
        )}
      </AddFlex>
      <Backdrop
        open={openGallery}
        style={{ position: "fixed", top: 0, left: 0, zIndex: 1111111 }}
        onClick={() => {
          setOpenGallery(false);
        }}
      >
        <></>
      </Backdrop>
    </>
  );
}

export default ImageUploadComponent;
